import { Component, OnInit } from '@angular/core';
import { OrganizationSetupCommon } from '../organization-setup.common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MasterDataService } from 'src/app/services/master-data.service';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { OrganizationSetupService } from 'src/app/services/organization-setup.service';
import * as moment from 'moment';
import Swal from 'sweetalert2';
import { CommonMessageService } from 'src/app/services/common-message.service';

@Component({
  selector: 'app-article-stipend',
  templateUrl: './article-stipend.component.html',
  styleUrls: ['./article-stipend.component.css']
})
export class ArticleStipendComponent implements OnInit {
  selectedFY: any;
  selectedBranch: any;
  branchList: any;
  financialYearList: any;

  modalFormObjList: any;
  modalForm: any;
  modalStatus: any;
  formSubmitted = false;
  formErrors = OrganizationSetupCommon.artcleStipendFormErrors;
  formValidationMessages = OrganizationSetupCommon.artcleStipendFormValidationMessages;

  constructor(private organizationSetupService: OrganizationSetupService,
    private masterDataService: MasterDataService,
    private fb: FormBuilder, private modalService: NgbModal,
    private commonMessageService:CommonMessageService) { }

  ngOnInit(): void {
    this.selectedFY = null;
    this.initModalForm();
    this.loadFinancialYear();
    this.modalForm.valueChanges.subscribe((data) => {
      this.logValidationErrors(this.modalForm);
    });
  }

  loadFinancialYear() {
    this.masterDataService.getFinancialYear()
      .subscribe(res => {
        console.log(res);
        this.financialYearList = res;

        var fyIndex = -1;
        this.financialYearList.forEach((element, key) => {
          var startDate = new Date(element.startDate);
          var endDate = new Date(element.endDate);
          // var currentDate = new Date();
          var currentDate = moment(new Date()).format('YYYY-MM-DD');
          console.log(startDate, endDate);
          console.log(currentDate);
          if (
            currentDate >= element.startDate &&
            currentDate <= element.endDate
          ) {
            fyIndex = key;
          }
        });
        this.selectedFY = this.financialYearList[fyIndex];
        console.log("this.selectYear", this.selectedFY)

        this.loadBranch();
      });
  }

  loadArticleStipend() {
    if (this.selectedFY == "Select" || this.selectedBranch == "Select") {
      this.commonMessageService.swalAlertWithoutIcon('',"select values in both field")
    } else {
      this.organizationSetupService.getArticleStipend(this.selectedFY.id, this.selectedBranch.id)
        .subscribe(res => {
          console.log(res);
          this.modalFormObjList = res;
        });
    }
  }

  loadBranch() {
    this.masterDataService.getBranch()
      .subscribe(res => {
        console.log(res);
        this.branchList = res;
        var branchIndex = -1;
        this.branchList.forEach((element, key) => {
          if (element.name == 'Pune') {
            branchIndex = key;
          }
        });
        this.selectedBranch = this.branchList[branchIndex];
        console.log("this.selectedBranch", this.selectedBranch)
        this.loadArticleStipend()
      });
  }

  initModalForm() {
    this.modalForm = this.fb.group({
      id: [''],
      financialYear: [null, [Validators.required]],
      branch: [null, [Validators.required]],
      articleYear: ['', [Validators.required]],
      effectiveDate: ['', [Validators.required]],
      stipendPerMonth: ['', [Validators.required]],
    });
  }

  // Modal Code
  openModal(content, status) {
    this.modalStatus = status;
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'md', windowClass: "animate__animated animate__slideInUp animate__faster" }).result.then((result) => {
    }, (reason) => {
    });
  }

  closeModal() {
    this.modalService.dismissAll();
    this.resetModalForm();
  }

  resetModalForm() {
    this.formSubmitted = false;
    this.modalForm.reset();
  }

  //----------------------

  onDeleteClick(item) {
    console.log(item);
    Swal.fire({
      text: 'Are you sure you want to remove?',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      confirmButtonColor:'#800000'
    }).then((result) => {
      if (result.isConfirmed) {
         this.modalStatus = 'delete';
         this.organizationSetupService.deleteArticleStipend(item.id)
         .subscribe(resp => {
          console.log(resp);
          this.changeModalFormObjList(item);
        this.commonMessageService.swalAlertWithIcon('','Deleted Successfully!','success');
      })
      }
    })
  }

  onSaveClick() {
    console.log(this.modalForm);
    this.formSubmitted = true;
    this.logValidationErrors(this.modalForm);
    if (this.modalForm.valid) {
      this.organizationSetupService.saveArticleStipend(this.getValueFromModalForm())
        .subscribe(resp => {
          console.log(resp);
          this.closeModal();
          this.changeModalFormObjList(resp);
            this.commonMessageService.swalAlertWithIcon('','Saved Successfully!','success');
        })
    }
  }

  // ----------------------------
  getValueFromModalForm() {
    var effectiveDate = new Date(this.modalForm.value.effectiveDate.year + '-' + this.modalForm.value.effectiveDate.month + '-' + this.modalForm.value.effectiveDate.day);
    var jsonValue = {
      id: this.modalForm.value.id,
      financialYear: this.modalForm.value.financialYear,
      branch: this.modalForm.value.branch,
      articleYear: this.modalForm.value.articleYear,
      effectiveDate: moment(effectiveDate).format("YYYY-MM-DD"),
      stipendPerMonth: this.modalForm.value.stipendPerMonth,

    }
    return JSON.stringify(jsonValue);
  }

  setValueToModalForm(modalObj) {
    console.log(modalObj);
    const fyIndex = this.financialYearList.findIndex(item => item.id == modalObj.financialYear.id);
    const branchIndex = this.branchList.findIndex(item => item.id == modalObj.branch.id);
    var effectiveDate = new Date(modalObj.effectiveDate);
    var effectiveDate1 = moment(effectiveDate, 'YYYY/MM/DD');
    this.modalForm.patchValue({
      id: modalObj.id,
      financialYear: this.financialYearList[fyIndex],
      branch: this.branchList[branchIndex],
      articleYear: modalObj.articleYear,
      effectiveDate: { year: parseInt(effectiveDate1.format('YYYY')), month: parseInt(effectiveDate1.format('M')), day: parseInt(effectiveDate1.format('D')) },
      stipendPerMonth: modalObj.stipendPerMonth,
    });
  }

  viewModalFormObj(formObj, content) {
    this.organizationSetupService.viewArticleStipend(formObj.id)
      .subscribe(resp => {
        this.setValueToModalForm(resp);
        this.openModal(content, 'edit');
      })
  }

  onEditClick(modalContent, formObj) {
    console.log(formObj);
    // this.viewModalFormObj(formObj,modalContent);
    this.setValueToModalForm(formObj);
    this.openModal(modalContent, 'edit');
  }

  onUpdateClick() {
    console.log(this.modalForm);
    console.log(this.modalForm.value);
    this.formSubmitted = true;
    this.logValidationErrors(this.modalForm);
    if (this.modalForm.valid) {
      this.organizationSetupService.updateArticleStipend(this.getValueFromModalForm())
        .subscribe(resp => {
          console.log(resp);
          this.changeModalFormObjList(resp);
          this.closeModal();
          this.commonMessageService.swalAlertWithIcon('','Updated Successfully!','success');     
        })
    }
  }

  //Setting
  changeModalFormObjList(modalFormObj) {
    if (this.modalStatus == 'add') {
      this.modalFormObjList.push(modalFormObj);
    }
    if (this.modalStatus == 'edit') {
      var index = this.modalFormObjList.findIndex(item => item.id === modalFormObj.id)
      this.modalFormObjList.splice(index, 1, modalFormObj);
    }
    if (this.modalStatus == 'delete') {
      var index = this.modalFormObjList.findIndex(item => item.id === modalFormObj.id)
      this.modalFormObjList.splice(index, 1);
    }
  }



  logValidationErrors(group: FormGroup): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        // console.log('Key = ' + key + ' && Value = ' + abstractControl.value);
        this.formErrors[key] = '';
        if (abstractControl && !abstractControl.valid && this.formSubmitted) {
          const messages = this.formValidationMessages[key];
          for (const errorKey in abstractControl.errors) {
            console.log(errorKey)
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }
      }
    });
  }

}
